import { useCallback, useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { trackEvent } from '../../../analytics/sml/analytics';
import { getPromoteMediaDraft } from '../draftStore';

type ComposerResult = 'posted' | 'draft';

/** The place that opened the Composer, read from its address and the media draft. */
function composerSource(params: URLSearchParams): string {
  if (params.has('postUuid')) {
    return 'editPost';
  }
  if (params.has('date') || params.has('platform')) {
    return 'calendar';
  }
  return getPromoteMediaDraft() === undefined ? 'menu' : 'postIt';
}

/** `composer_opened` when the screen opens and `composer_closed` when it goes. */
export function useComposerEvents(): { markResult: (result: ComposerResult) => void } {
  const [params] = useSearchParams();
  const result = useRef<ComposerResult | null>(null);
  const source = useRef(composerSource(params));
  useEffect(() => {
    trackEvent('composer_opened', { source: source.current });
    return () => {
      trackEvent('composer_closed', { result: result.current ?? 'abandoned' });
    };
  }, []);
  const markResult = useCallback((next: ComposerResult) => {
    result.current = next;
  }, []);
  return { markResult };
}
